import React from 'react';

import config from '../../config';
import { PickupSlotsContext } from '../timeSlots/PickupSlotsProvider';
import StoreNotOpenBanner from './StoreNotOpenBanner';
import ErrorIcon from '@material-ui/icons/Error';
import ErrorMessageBanner from '../styleguide/ErrorMessageBanner';
import PropTypes from 'prop-types';

import styles from './DispensaryMessage.module.css';

/**
 *  For any important message we want to display in the dispensary header 
 *  "Delivery not avialable" etc.
 */
const DispensaryMessage = ({
  dispensaryId,
  dispensaryName,
  dispensaryLocation={},
  deliveryZipCodes=[],
  deliveryAddress={},
  isPickup,
  anonymousZipCode
}) => {

  // Handle outside biz hours/orders not accepted at this time
  const { ordersDisabled } = React.useContext(PickupSlotsContext);

  const deliveryZipCode = deliveryAddress.zip_code || anonymousZipCode;
  const deliveryNotAvailable = deliveryZipCode && deliveryZipCodes.length &&
                               deliveryZipCodes.indexOf(deliveryZipCode) === -1;

  const iconStyle = {verticalAlign:'-5px'};
 
  // Check config for disabled/paused ordering
  const orderingPaused = config.PAUSED_DISPENSARIES.includes(dispensaryId);

  const msgClass = isPickup 
                   ? styles.pickupMsg 
                   : deliveryNotAvailable
                     ? styles.warning 
                     : '';

  return (
    <>
      { orderingPaused /* technical issues */
        ? <ErrorMessageBanner
            text={<>Online ordering has been temporarily paused for 
              {' '}<b>{dispensaryName}</b>, we apologize for the service interruption. 
              {' '}Please check back&nbsp;later...</>}
          />
        : ordersDisabled /* outside biz hours */
          ? <StoreNotOpenBanner dispensaryName={dispensaryName} />
          : isPickup
            ? <>
                <div className={`${styles.dispensaryMsg} ${msgClass}`}>
                  <div className={styles.msgHdr}>
                    This is a pickup order:
                  </div>
                  <div className={styles.msgDetails}>
                    you'll need to go to {dispensaryName} to pick up this order: <b>{dispensaryLocation.street_address}</b>
                  </div>
                </div>
              </>
            : deliveryNotAvailable
              ? <div className={`${styles.dispensaryMsg} ${msgClass}`}>
                  <div className={styles.msgHdr}>
                    <ErrorIcon style={iconStyle} /> {dispensaryName} does not deliver to {deliveryZipCode}
                  </div>
                </div>
              : null
      }
    </>
  );
} 

DispensaryMessage.propTypes = {
  isPickup: PropTypes.bool,
  dispensaryId: PropTypes.string.isRequired,
  dispensaryName: PropTypes.string.isRequired,
  dispensaryLocation: PropTypes.object.isRequired,
  deliveryZipCodes: PropTypes.array.isRequired,
  deliveryAddress: PropTypes.object,
  anonymousZipCode: PropTypes.string
};

export default DispensaryMessage;